import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, withKeys as _withKeys, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0297fda"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("代付预警")
const _hoisted_5 = { style: {"padding":"0 12px"} }
const _hoisted_6 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_7 = { style: {"padding":"0 12px"} }
const _hoisted_8 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_9 = { style: {"padding":"0 12px"} }
const _hoisted_10 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_11 = { style: {"padding":"0 12px"} }
const _hoisted_12 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_13 = { style: {"padding":"0 12px"} }
const _hoisted_14 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_15 = {
  class: "payId-text",
  style: {"padding":"0 12px"}
}
const _hoisted_16 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_17 = { style: {"padding":"0 12px"} }
const _hoisted_18 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_19 = { style: {"padding":"0 12px"} }
const _hoisted_20 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("查看凭证")
const _hoisted_22 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_23 = { class: "d-flex justify-content--between" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("加入黑名单")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("加入白名单")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("本次忽略")
const _hoisted_27 = { style: {"padding":"0 12px"} }
const _hoisted_28 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_29 = { style: {"padding":"0 12px"} }
const _hoisted_30 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_31 = { style: {"padding":"0 12px"} }
const _hoisted_32 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_33 = { class: "pt-10" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("加入黑名单")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("加入白名单")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("本次忽略")
const _hoisted_38 = { style: {"padding":"0 12px","text-align":"right"} }
const _hoisted_39 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_40 = { style: {"padding":"0 12px"} }
const _hoisted_41 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_42 = { style: {"padding":"0 12px"} }
const _hoisted_43 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_44 = { style: {"padding":"0 12px"} }
const _hoisted_45 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_46 = { style: {"padding":"0 12px"} }
const _hoisted_47 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_48 = {
  class: "payId-text",
  style: {"padding":"0 12px"}
}
const _hoisted_49 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_50 = { style: {"padding":"0 12px"} }
const _hoisted_51 = {
  key: 0,
  class: "table-divder"
}
const _hoisted_52 = { class: "pt-10" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_56 = ["infinite-scroll-distance"]
const _hoisted_57 = { style: {textAlign: 'center'} }

import { ref, reactive, onMounted,nextTick,inject } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'
import { useLocale, configProviderContextKey } from 'element-plus'
import * as PDFJS from 'pdfjs-dist'

export default /*#__PURE__*/_defineComponent({
  emits: ['refreshRoster'],
  setup(__props, { emit }) {

PDFJS.GlobalWorkerOptions.workerSrc = "pdfjs/pdf.worker.js"
let {
    // 代付凭证_查询
    'POST/order/payment_voucher/query':paymentVoucherQueryApi,
    // 代付凭证_代付预警_查询
    'POST/order/payment_voucher/alert/query':paymentVoucherAlertApi,
    // 代付凭证_加入黑、白名单
    'POST/order/payment_voucher/roster/save':rosterApi,
    // 预览
    'GET/upload/download_file':downloadFileApi,
    // 预览
    'GET/order/payment_voucher/{id}/files':paymentVoucherFileListApi,
} = Api

const pageInfo=reactive({
    page:1,
    size:10,
    total:0
})
const tableHeight = window.innerHeight-300
const queryInfo=ref<any>({})
const voucherLists=ref<any>([])
const loadingDtata=reactive({
    list:false,
    roster:false
})

const getVoucherLists=(isReset:boolean=false)=>{
    if(isReset){
        pageInfo.page=1
        queryInfo.value={}
    }
    let {page,size}=pageInfo
    let {voucherUpload}=queryInfo.value
    let params={
        query:{voucherUpload},
        page,size
    }
    loadingDtata.list=true
    paymentVoucherQueryApi(params).then((res:any)=>{
        voucherLists.value=res.data
        pageInfo.total=res.rowCount
    }).finally(()=>{
        loadingDtata.list=false
    })
}

const payDialogVisible=ref(false)
const paymentVoucherAlert=ref([])
const alertSelectedData=ref([])
const paymentPageInfo=reactive({
    page:1,
    size:10,
    total:0
})
const showRosteHandle=()=>{   
    payerId.value="" 
    payDialogVisible.value=true
    getPaymentVocherAlert()
}
const selectChange=(value:any)=>{
    alertSelectedData.value=value
}
const payerId=ref('')
const getPaymentVocherAlert=()=>{
    let {page,size}=paymentPageInfo
    let params={
        query:{
            payerId:payerId.value
        },
        page,
        size
    }
    loadingDtata.roster=true
    paymentVoucherAlertApi(params).then((res:any)=>{
        paymentVoucherAlert.value=res.data
        paymentPageInfo.total=res.rowCount
    }).finally(()=>{
        loadingDtata.roster=false
    })
}
const rosterSaveHandle= async (type:any,isHistory:boolean=false)=>{    
    if(!isHistory&&!alertSelectedData.value){
        ElMessage.warning('请勾选需要数据')
        return
    }
    let message=type==1||type==2?`确认加入${type==2?'白名单':'黑名单'}？`:'确认忽略本次预警？'
    let res=await ElMessageBox.confirm(message,{confirmButtonClass:'确认',cancelButtonText:'取消'})
    if(!res)return
    let params=!isHistory?{
        orderPayerRosters:alertSelectedData.value.map((el:any)=>{
            let {payerId,payType,orderIdList}=el
            return {
                payerId,payType,orderIdList,type
            }
        })
    }:{
        orderPayerRosters: [{payerId:currentHistory.value.payerId,
        payType:currentHistory.value.payType,
        orderIdList:currentHistory.value.orderIdList,
        type}]
    }
    rosterApi(params).then(()=>{
        ElMessage.success('操作成功')
        alertSelectedData.value=[]
        if(isHistory){
            historyVisiable.value=false
            currentHistory.value={}
        }
        getPaymentVocherAlert()
        emit('refreshRoster')
    })
}
const previewUrl=ref('')
const showViewer=ref(false)
const previewHandle=(row:any)=>{
    let params={
        fileId:row.fileId
    }
    downloadFileApi(params,{timeout: 5 * 60000, responseType: 'blob'}).then((res:any)=>{
        let url= window.URL.createObjectURL(
            new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
        )
        if(res.data.type=='image/jpeg'||res.data.type=='image/png'||res.data.type=='image/jpg'){ //预览
            console.log(res.data.type)
            showViewer.value=true   
            previewUrl.value=url        
            return
        }
        if(res.data.type=='application/pdf'){
            handleInitPdf(url)
            return
        }
        // 下载
        let fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        let link = document.createElement("a")
        link.style.display = "none"
        link.href = url
        link.setAttribute(
        "download",
        decodeURI(fileName)
        )
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
    })
}
const historyVisiable=ref(false)
const currentHistory=ref<any>({})
const showHisory=(row:any)=>{
    currentHistory.value=row
    historyVisiable.value=true
}

const voucherFilesVisiable=ref(false)
const voucherFilesLoading=ref(false)
const voucherFiles=ref([])
const checkVoucher=(id:any)=>{
    voucherFilesVisiable.value=true
    voucherFilesLoading.value=true
    paymentVoucherFileListApi({id}).then((res:any)=>{
        voucherFiles.value=res
    }).finally(()=>{
        voucherFilesLoading.value=false
    })
}
const pdfPreview=ref(false)
const  previewContentWidth = ref<number>(855)
let currentPage = ref(1)
let totalPages = ref(0)
let pdfObj: any = null;
const handleInitPdf = (url: string) => {
    pdfPreview.value = true
  currentPage.value = 1
  nextTick(() => {
    // 初始化在线预览pdf
    PDFJS.getDocument({url, cMapUrl: 'cmaps/', cMapPacked: true,}).promise.then((pdf: any) => {
      // 设置展示比例
      let outputScale = window.devicePixelRatio || 1;
      let transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0]: null;
      totalPages.value = pdf.numPages
      pdfObj = pdf
    }).then(() => {
      load()
    })
  })
};
let renderTask: any
const load = () => {
  if(currentPage.value > totalPages.value){
    return
  }
  // let pdfElement = document.getElementById('pdfContainerRef')
  let pdfElement = document.getElementsByClassName('pdfContainerRef' + currentPage.value)[0]
  pdfObj.getPage(currentPage.value).then((page: any) => {
    // 用来计算页面宽度以变更缩放比例
    // var desiredWidth = document.body.clientWidth || document.body.offsetWidth || document.body.scrollWidth;
    var viewport = page.getViewport({ scale: 1.3 });
    // 创建canvas元素并绘制内容
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    let _width = viewport.width + 55
    previewContentWidth.value = _width > 1650 ? 1650 : _width

    canvas.width = Math.floor(viewport.width *  1);
    canvas.height = Math.floor(viewport.height *  1);

    // 在canvas画布上绘制pdf
    const renderContext = {
      canvasContext: context,
      viewport: viewport,
      // transform: window.devicePixelRatio !== 1 ? [window.devicePixelRatio, 0, 0, window.devicePixelRatio, 0, 0]: null
    };

    renderTask = page.render(renderContext);

    
    pdfElement.appendChild(canvas);
    // 渲染完成执行
    // renderTask.promise.then(() => {loading.value = false}); 
  })
  currentPage.value += 1
}

// 缩放
let scale = ref<number>(1)
const zoomHandle = (isShrink: boolean) => {
  if(isShrink && scale.value <= 1.6){
    // 放大
    scale.value += 0.2
    // load()
  }
  if(!isShrink && scale.value > 1){
    // 缩小
    scale.value -= 0.2
    // load()
  }
}

// 关闭弹框
const closeHandle = () => {
  scale.value = 1
  // pdfObj = null
  // 清零页数,否则二次调用初始化函数,会加载上一次pdf
  totalPages.value = 0
  // renderTask.cleanup()
}


onMounted(()=>{
    getVoucherLists()
    getPaymentVocherAlert()
    // console.log(pdfjsLib)
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_collapse, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_collapse_item, { title: "点击搜索" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "代付凭证：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: queryInfo.value.voucherUpload,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.voucherUpload) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "已上传",
                            value: true
                          }),
                          _createVNode(_component_el_option, {
                            label: "未上传",
                            value: false
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (getVoucherLists())),
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (getVoucherLists(true)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_el_badge, {
        value: _unref(paymentPageInfo).total,
        class: "item"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: showRosteHandle,
            type: "danger"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        maxHeight: tableHeight,
        class: "mt-10",
        data: voucherLists.value,
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "no",
            label: "订单号",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "customerUsername",
            label: "客户ID",
            width: "130"
          }),
          _createVNode(_component_el_table_column, {
            prop: "owner",
            label: "客户经理",
            width: "130"
          }),
          _createVNode(_component_el_table_column, {
            prop: "currency",
            label: "币种"
          }),
          _createVNode(_component_el_table_column, {
            prop: "amount",
            label: "金额",
            formatter: _unref(formatNumber),
            width: "120",
            align: "right"
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            label: "二维码收款记录",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "金额",
                align: "right"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.paymentAmount), 1),
                      (index < row.orderPayRecordList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "创建时间",
                width: "190"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(item.createTime), 1),
                      (index < row.orderPayRecordList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "创建人"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.createName||''), 1),
                      (index < row.orderPayRecordList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "支付状态"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item.tradeState||''), 1),
                      (index < row.orderPayRecordList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "收款方式"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(item.payType == 'WECHAT' ? '微信' :'支付宝'), 1),
                      (index < row.orderPayRecordList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "payerId",
                "class-name": "alert-column-dvider",
                label: "付款ID"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: item.payerId,
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(item.payerId||''), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"]),
                      (index < row.orderPayRecordList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "是否合并收款"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(item.merge?"是":'否'), 1),
                      (index < row.orderPayRecordList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "voucherFileId",
            "class-name": "alert-column-dvider",
            label: "代付凭证"
          }, {
            default: _withCtx(({row}) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(item.voucherFileIdList?'已上传':'未上传'), 1),
                  (index < row.orderPayRecordList.length-1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx(({row}) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [
                  _createVNode(_component_el_link, {
                    onClick: ($event: any) => (checkVoucher(item.id)),
                    underline: false,
                    disabled: !item.voucherFileIdList?true:false,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  (index < row.orderPayRecordList.length-1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(loadingDtata).list]
      ]),
      _createVNode(_component_el_pagination, {
        background: "",
        small: "",
        total: _unref(pageInfo).total,
        currentPage: _unref(pageInfo).page,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pageInfo).page) = $event)),
        "page-size": _unref(pageInfo).size,
        "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_unref(pageInfo).size) = $event)),
        class: "mb-5 mt-5",
        onSizeChange: _cache[5] || (_cache[5] = ()=>getVoucherLists()),
        onCurrentChange: _cache[6] || (_cache[6] = ()=>getVoucherLists()),
        "page-sizes": [10, 30, 50, 100, 500, 1000, 2000],
        layout: "sizes, prev, pager, next, total, jumper"
      }, null, 8, ["total", "currentPage", "page-size"]),
      _createVNode(_component_el_dialog, {
        modelValue: payDialogVisible.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((payDialogVisible).value = $event)),
        title: "代付预警"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_el_button, {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (payDialogVisible.value=false))
            }, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (rosterSaveHandle(1))),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (rosterSaveHandle(2))),
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "info",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (rosterSaveHandle(3)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_input, {
              style: {"width":"220px"},
              onKeydown: _cache[10] || (_cache[10] = _withKeys(($event: any) => (getPaymentVocherAlert()), ["enter"])),
              modelValue: payerId.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((payerId).value = $event)),
              placeholder: "搜索付款ID"
            }, null, 8, ["modelValue"])
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            "max-height": "500",
            onSelectionChange: selectChange,
            class: "mt-10",
            data: paymentVoucherAlert.value,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { type: "selection" }),
              _createVNode(_component_el_table_column, {
                prop: "payerId",
                label: "付款ID",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "payType",
                label: "支付方式",
                formatter: (row)=>row.payType == 'WECHAT' ? '微信' :'支付宝'
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "abnormalPaymentAmount",
                label: "异常收款金额统计",
                align: "right"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_link, {
                    underline: false,
                    type: "primary",
                    onClick: ($event: any) => (showHisory(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getNumber(row.abnormalPaymentAmount)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "客户Id"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(item.customerUsername), 1),
                      (index < row.orderList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "客户名称"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(item.customer), 1),
                      (index < row.orderList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "class-name": "alert-column-dvider",
                label: "客户经理"
              }, {
                default: _withCtx(({row}) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(item.owner), 1),
                      (index < row.orderList.length-1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(loadingDtata).roster]
          ]),
          _createVNode(_component_el_pagination, {
            background: "",
            small: "",
            total: _unref(paymentPageInfo).total,
            currentPage: _unref(paymentPageInfo).page,
            "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => ((_unref(paymentPageInfo).page) = $event)),
            "page-size": _unref(paymentPageInfo).size,
            "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => ((_unref(paymentPageInfo).size) = $event)),
            class: "mb-5 mt-5",
            onSizeChange: _cache[14] || (_cache[14] = ()=>getPaymentVocherAlert()),
            onCurrentChange: _cache[15] || (_cache[15] = ()=>getPaymentVocherAlert()),
            "page-sizes": [10, 30, 50, 100, 500, 1000, 2000],
            layout: "sizes, prev, pager, next, total, jumper"
          }, null, 8, ["total", "currentPage", "page-size"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: historyVisiable.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((historyVisiable).value = $event)),
        title: "异常收款记录",
        width: "90%"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_el_button, {
              onClick: _cache[21] || (_cache[21] = ($event: any) => (historyVisiable.value=false))
            }, {
              default: _withCtx(() => [
                _hoisted_53
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (rosterSaveHandle(1,true))),
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (rosterSaveHandle(2,true))),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "info",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (rosterSaveHandle(3,true)))
              }, {
                default: _withCtx(() => [
                  _hoisted_37
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_table, {
            class: "mt-10",
            data: currentHistory.value.orderList,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "no",
                label: "订单号",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "customerUsername",
                label: "客户ID",
                width: "130"
              }),
              _createVNode(_component_el_table_column, {
                prop: "owner",
                label: "客户经理",
                width: "130"
              }),
              _createVNode(_component_el_table_column, {
                prop: "currency",
                label: "币种"
              }),
              _createVNode(_component_el_table_column, {
                prop: "amount",
                label: "金额",
                formatter: _unref(formatNumber),
                width: "120",
                align: "right"
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                label: "二维码收款记录",
                align: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    "class-name": "alert-column-dvider",
                    label: "金额",
                    align: "right"
                  }, {
                    default: _withCtx(({row}) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id
                        }, [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(item.paymentAmount), 1),
                          (index < row.orderPayRecordList.length-1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    "class-name": "alert-column-dvider",
                    label: "创建时间",
                    width: "190"
                  }, {
                    default: _withCtx(({row}) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id
                        }, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(item.createTime), 1),
                          (index < row.orderPayRecordList.length-1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    "class-name": "alert-column-dvider",
                    label: "创建人"
                  }, {
                    default: _withCtx(({row}) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id
                        }, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(item.createName||''), 1),
                          (index < row.orderPayRecordList.length-1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    "class-name": "alert-column-dvider",
                    label: "支付状态"
                  }, {
                    default: _withCtx(({row}) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id
                        }, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(item.tradeState||''), 1),
                          (index < row.orderPayRecordList.length-1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    "class-name": "alert-column-dvider",
                    label: "收款方式"
                  }, {
                    default: _withCtx(({row}) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id
                        }, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(item.payType == 'WECHAT' ? '微信' :'支付宝'), 1),
                          (index < row.orderPayRecordList.length-1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "payerId",
                    "class-name": "alert-column-dvider",
                    label: "付款ID"
                  }, {
                    default: _withCtx(({row}) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id
                        }, [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: item.payerId,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_48, _toDisplayString(item.payerId||''), 1)
                            ]),
                            _: 2
                          }, 1032, ["content"]),
                          (index < row.orderPayRecordList.length-1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    "class-name": "alert-column-dvider",
                    label: "是否合并收款"
                  }, {
                    default: _withCtx(({row}) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.orderPayRecordList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id
                        }, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(item.merge?"是":'否'), 1),
                          (index < row.orderPayRecordList.length-1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        onClose: _cache[24] || (_cache[24] = ($event: any) => (voucherFiles.value=[])),
        modelValue: voucherFilesVisiable.value,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((voucherFilesVisiable).value = $event)),
        title: "查看凭证"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (voucherFilesVisiable.value=false))
          }, {
            default: _withCtx(() => [
              _hoisted_55
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: voucherFiles.value,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "文件名",
                width: "290",
                "show-overflow-tooltip": "",
                prop: "filename"
              }),
              _createVNode(_component_el_table_column, {
                label: "备注",
                prop: "note"
              }),
              _createVNode(_component_el_table_column, {
                label: "上传时间",
                width: "180",
                prop: "uploadAt"
              }),
              _createVNode(_component_el_table_column, {
                label: "预览",
                width: "80",
                prop: "preview"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_link, {
                    onClick: ($event: any) => (previewHandle(row)),
                    underline: false,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_54
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, voucherFilesLoading.value]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (showViewer.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "hide-on-click-modal": "",
          onClose: _cache[26] || (_cache[26] = ()=>{showViewer.value = false}),
          "url-list": [ previewUrl.value]
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "预览",
      modelValue: pdfPreview.value,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((pdfPreview).value = $event)),
      "append-to-body": true,
      onClosed: closeHandle,
      width: previewContentWidth.value,
      top: "50px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_57, [
          _createVNode(_component_el_button, {
            onClick: _cache[27] || (_cache[27] = ($event: any) => (zoomHandle(true))),
            icon: "Plus",
            type: "primary"
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (zoomHandle(false))),
            icon: "Minus"
          })
        ])
      ]),
      default: _withCtx(() => [
        (pdfPreview.value)
          ? _withDirectives((_openBlock(), _createElementBlock("ul", {
              key: 0,
              id: "pdfContainerRef",
              "infinite-scroll-distance": 8000 - 4000 * _unref(scale)
            }, [
              _createElementVNode("div", {
                class: "pdfContainerLiContent",
                style: _normalizeStyle({ transform: `scale(${_unref(scale)})`})
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(totalPages), (i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i,
                    class: _normalizeClass(["pdfContainerLi", 'pdfContainerRef' + i])
                  }, null, 2))
                }), 128))
              ], 4)
            ], 8, _hoisted_56)), [
              [_directive_infinite_scroll, load]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ], 64))
}
}

})